//Site modules
import {showPage} from "%import%/standalone/showPage";
import {headerHeightCalc, headerSticky} from "%modules%/header/header";
import {scrollTop} from "%components%/scrollTop/scrollTop";
import {mainMenu} from "%components%/main-menu/main-menu";

document.addEventListener('DOMContentLoaded', function () {
    headerSticky();
    mainMenu();
});

window.addEventListener('load', function () {
    showPage();
    scrollTop();
});


window.addEventListener('resize', function(event) {

});

headerHeightCalc();